import React, { MutableRefObject, RefObject, useEffect, useState } from "react";
import { Circle, Marker, MarkerClusterer } from "@react-google-maps/api";
// import uuidv4 from "uuid/v4";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import CustomMarker from "./CustomMarker";
import Map from "./Map";
import CustomButton from "../button";
import { CustomDiv } from "@/common/divs";
import { RegularText } from "@/common/texts";
import { ActivitySubCategory } from "@/model";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";
import { renderSubCategoryMarker } from "@/utils/functions";
import "./map.css";

interface MapContainerProps {
  locations: {
    lat: number;
    lng: number;
    ref: RefObject<any>;
    subcategory: ActivitySubCategory;
    categoryId: number;
  }[];
  center: { lat: number; lng: number };
  valuesState: MutableRefObject<any>;
  changeValuesForFetch: () => void;
  isMobile?: boolean;
}

const MapContainer: React.FC<MapContainerProps> = ({
  locations,
  center,
  valuesState,
  isMobile,
  changeValuesForFetch,
}) => {
  const [map, setMap] = useState(null);
  const [showButton, setShowButton] = useState(false);

  React.useEffect(() => {
    if (map) {
      // map.panTo(...)
      mapFitBounds();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  function mapFitBounds() {
    if (!map) return;

    const bounds = new google.maps.LatLngBounds();
    locations.map((loc) => {
      bounds.extend(new google.maps.LatLng(loc.lat, loc.lng));
    });

    //@ts-ignore
    map.fitBounds(bounds);
  }

  const clusterStyles = [
    {
      textColor: "black",
      url: "https://cdn.jsdelivr.net/gh/googlemaps/js-marker-clusterer@gh-pages/images/m2.png",
      height: 50,
      width: 50,
    },
    {
      textColor: "black",
      url: "https://cdn.jsdelivr.net/gh/googlemaps/js-marker-clusterer@gh-pages/images/m2.png",
      height: 50,
      width: 50,
    },
    {
      textColor: "white",
      url: "https://cdn.jsdelivr.net/gh/googlemaps/js-marker-clusterer@gh-pages/images/m1.png",
      height: 50,
      width: 50,
    },
  ];

  const removeOtherStyles = () => {
    locations.map((loc) => {
      loc.ref.current.style.border = "none";
      loc.ref.current.style.boxShadow = "none";
    });
  };
  const [iconState, setIconState] = useState<
    { url: string; scaledSize: google.maps.Size }[]
  >([]);
  const getAllIcons = () => {
    const icons: { url: string; scaledSize: google.maps.Size }[] = [];
    locations.map((loc) => {
      icons.push(
        renderSubCategoryMarker(loc.categoryId, loc.subcategory?.id ?? 0),
      );
    });
    setIconState(icons);
  };
  const changeSize = (index: number) => {
    setIconState((prev) => {
      return prev.map((icon, i) => {
        if (i === index) {
          return {
            url: icon.url,
            scaledSize: new window.google.maps.Size(40, 40),
          };
        } else {
          return {
            url: icon.url,
            scaledSize: new window.google.maps.Size(30, 30),
          };
        }
      });
    });
  };

  useEffect(() => {
    if (map) {
      getAllIcons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations, map]);

  const { t } = useTranslation();

  return (
    <div>
      <Map
        isMobile={isMobile}
        setMap={setMap}
        center={center}
        map={map}
        setShowButton={setShowButton}
        valuesState={valuesState}
        changeValuesForFetch={changeValuesForFetch}
      >
        <MarkerClusterer maxZoom={16} styles={clusterStyles}>
          {(clusterer) => (
            <React.Fragment>
              {locations.map((loc, index) => (
                <CustomMarker
                  removeOtherStyles={removeOtherStyles}
                  map={map}
                  key={uuidv4()}
                  position={loc}
                  clusterer={clusterer}
                  iconState={iconState[index]}
                  index={index}
                  changeSize={changeSize}
                />
              ))}
            </React.Fragment>
          )}
        </MarkerClusterer>
        <Marker
          icon={{
            fillColor: "#4285F4",
            fillOpacity: 1,
            path: 0,
            scale: 8,
            strokeColor: "rgb(255,255,255)",
            strokeWeight: 2,
          }}
          position={{ lat: center.lat, lng: center.lng }}
        />
        <Circle
          center={center}
          radius={50}
          options={{
            fillColor: "#61a0bf",
            fillOpacity: 0.1,
            strokeColor: "#1bb6ff",
            strokeOpacity: 0.4,
            strokeWeight: 1,
          }}
        />
        <CustomDiv
          className={`search-activity-button ${showButton ? "active" : ""}`}
        >
          <CustomButton
            onClick={() => changeValuesForFetch()}
            width="100%"
            height="55px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
          >
            <RegularText>{t("activity.map.search_on_this_zone")}</RegularText>
          </CustomButton>
        </CustomDiv>
      </Map>
    </div>
  );
};

export default MapContainer;
